import { firstOf, lastOf } from 'utils/arrays/elements.util';
import noNilArray from 'utils/arrays/noNilArray.util';
import sortArray from 'utils/arrays/sortedArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromAnyDateToIso, fromAnyDateToTimestamp } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import { isValidId } from 'utils/predicates/fields.util';

const L = logger('appointmentInfo'); // eslint-disable-line no-unused-vars

const bgnOf = (item) => item?.startTime ?? item?.start_time;
const endOf = (item) => item?.endTime ?? item?.end_time;

const compareB = (a, b) => fromAnyDateToTimestamp(bgnOf(a)) - fromAnyDateToTimestamp(bgnOf(b));
const compareE = (a, b) => fromAnyDateToTimestamp(endOf(a)) - fromAnyDateToTimestamp(endOf(b));

const clientNameOf = (appointment) => {
  const client = appointment?.client;
  return client?.userName ?? client?.user_name;
};

const appointmentInfo = (options) => {
  const appointment = options?.appointment;
  const appointmentId = appointment?.id;

  const procedures = noNilArray(appointment?.procedures);

  const bgnSortedProcedures = sortArray(compareB, procedures);
  const endSortedProcedures = sortArray(compareE, procedures);

  const hasAppointment = fromAnyToBool(appointment);
  const hasProcedures = fromAnyToBool(procedures.length);
  const hasValidAppointmentId = isValidId(appointmentId);

  return {
    appointmentId,
    isValid: hasAppointment && hasValidAppointmentId && hasProcedures,
    hasAppointment,
    hasValidAppointmentId,
    hasProcedures,
    bgn: fromAnyDateToIso(bgnOf(firstOf(bgnSortedProcedures))),
    end: fromAnyDateToIso(endOf(lastOf(endSortedProcedures))),
    clientName: fromAnyToString(clientNameOf(appointment)),
  };
};

export default appointmentInfo;
